import React, { useMemo, forwardRef } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { Tooltip } from '@mui/material';
import { MRT_Localization_PL } from 'material-react-table/locales/pl';

const KnowledgeBase = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Nazwa dokumentu',
        Cell: ({ cell }) => {
          const maxCharShown = 100;
          const cellText = cell.getValue();
          const downloadPath = cell.row.original.path;

          return (
            <CustomCellContainer>
              {cellText.length > maxCharShown ? (
                <Tooltip
                  title={cellText}
                  slotProps={{
                    tooltip: {
                      className: '!text-sm !max-w-md',
                    },
                  }}
                >
                  <a
                    href={downloadPath}
                    target="_blank"
                    className="underline text-[--tw-prose-links] underline-offset-2 break-words w-full"
                    download
                  >
                    {cellText.slice(0, maxCharShown).toLocaleString() + '...'}
                  </a>
                </Tooltip>
              ) : (
                <a
                  href={downloadPath}
                  target="_blank"
                  className="underline text-[--tw-prose-links] underline-offset-2 break-words w-full"
                  download
                >
                  {cellText}
                </a>
              )}
            </CustomCellContainer>
          );
        },
      },
      {
        accessorKey: 'authors',
        header: 'Autorzy',
        Cell: ({ cell }) => {
          const maxCharShown = 100;
          const cellText = cell.getValue();
          return (
            <CustomCellContainer>
              {cellText.length > maxCharShown ? (
                <Tooltip
                  title={cellText}
                  slotProps={{
                    tooltip: {
                      className: '!text-sm !max-w-md',
                    },
                  }}
                >
                  <span className="break-words w-full">
                    {cellText.slice(0, maxCharShown).toLocaleString() + '...'}
                  </span>
                </Tooltip>
              ) : (
                <span>{cellText}</span>
              )}
            </CustomCellContainer>
          );
        },
      },
      {
        accessorKey: 'created',
        header: 'Utworzony',
      },
    ],
    [data],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableFullScreenToggle: false,
    enableHiding: false,
    localization: MRT_Localization_PL,
    initialState: {
      showGlobalFilter: true, // show search bar expanded by default
      pagination: { pageSize: 25, pageIndex: 0 },
    },
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25, 50, 100],
    },
  });

  return (
    <div className="not-prose w-full">
      <MaterialReactTable table={table} />
    </div>
  );
};

export default KnowledgeBase;

const CustomCellContainer = ({ children }) => {
  return <div className="flex gap-2 min-w-0 max-w-[50ch]">{children}</div>;
};
